import { useState } from 'react';
import type { ChangeEvent } from 'react';
import { t } from 'i18next';

interface YearPickerProps {
  initYear?: number;
  minYear: number;
  maxYear: number;
  postfix?: string;
  prefix?: string;
  placeholder?: string;
  onSelectedYear: (year: string) => void;
}

const YearPicker = ({
  initYear,
  minYear,
  maxYear,
  postfix = '',
  prefix = '',
  placeholder = t('select') as string,
  onSelectedYear
}: YearPickerProps) => {
  const startYear = minYear || new Date().getFullYear() - 100;
  const endYear = maxYear || new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<string>('');

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedYear(value);
    if (value !== '') onSelectedYear(value);
  };

  const currentValue =
    selectedYear !== '' ? selectedYear : initYear !== undefined ? String(initYear) : '';

  return (
    <div className="w-full">
      <select
        value={currentValue}
        onChange={handleChange}
        className={`
    border-[1px] border-separator1
    text-text-main-lv3 text-[17px] font-semibold leading-[20px] text-center
    bg-transparent py-[16px] w-full rounded-[8px]
    focus:outline-none focus:border-[1px] focus:border-text-main-lv2 
    focus:bg-label-light dark:focus:bg-label-dark focus:text-text-main-lv2
    aria-selected:border-[1px] aria-selected:border-text-main-lv2
    aria-selected:bg-label-light dark:aria-selected:bg-label-dark aria-selected:text-text-main-lv2
    ${currentValue !== '' ? 'selected' : ''}
  `}
        style={{
          textAlign: 'center' as const,
          textAlignLast: 'center',
          direction: 'ltr',
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          outline: 'none'
        }}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {Array.from({ length: endYear - startYear + 1 }, (_, index) => {
          const year = endYear - index;
          return (
            <option key={year} value={year} style={{ textAlign: 'center', direction: 'ltr' }}>
              {prefix}
              {year}
              {postfix}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default YearPicker;
